import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, DownloadIcon, PencilIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { priceToday, totalValue } from '../data/content';
const proofs = [{
  icon: ClockIcon,
  label: 'Listo en menos de 10 minutos'
}, {
  icon: PencilIcon,
  label: '100% editable en Canva'
}, {
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ivory" data-id="element-50" data-mp="128yzkcr9hvyn">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-6 pb-16 pt-14 lg:grid-cols-[1.05fr_1fr] lg:gap-16 lg:px-10 lg:pb-24 lg:pt-20" data-id="element-51" data-mp="xa4gratao7ej">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-52" data-mp="sd4aozwg34nf">
          <p className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-wine" data-id="element-53" data-mp="3d2tqpg8vwwhp">
            Mega Pack Editable 2026
          </p>
          <h1 className="mt-5 font-display text-[2.6rem] font-semibold leading-[1.05] tracking-tight text-ink sm:text-6xl lg:text-[4.1rem]" data-id="element-54" data-mp="3j7zfnjujfuh7">
            Cómo garantizar una boda inolvidable y{' '}
            <em className="italic text-wine" data-id="element-55" data-mp="39auqdb5ebiw6">cero aburrida</em> en menos de 10 minutos
          </h1>
          <p className="mt-5 max-w-prose font-sans text-base leading-relaxed text-muted sm:text-lg" data-id="element-56" data-mp="3e8wkqs89v4my">
            Incluso si estás al borde de un colapso por el estrés. El sistema de plantillas e
            interacción que transforma los “tiempos muertos” en el mejor recuerdo de tus invitados.
          </p>

          <div className="mt-8 border-l-2 border-blush pl-5" data-id="element-57" data-mp="2qkmsp8kgtknd">
            <p className="max-w-prose font-display text-xl leading-snug text-ink sm:text-2xl" data-id="element-58" data-mp="2qi0lxb5ef967">
              “Olvídate de las caras largas, los invitados mirando el reloj y el pánico de que algo
              salga mal. Toma el control total del entretenimiento de tu boda.”
            </p>
          </div>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-59" data-mp="s21j2e1koi11">
            <CtaButton data-id="element-60" data-mp="s3undmopqq5v">Quiero mi boda divertida — {priceToday}</CtaButton>
            <p className="font-sans text-sm text-muted" data-id="element-61" data-mp="na0b34bftdgt">
              Pago único · Acceso de por vida
            </p>
          </div>

          <ul className="mt-10 flex flex-wrap gap-x-7 gap-y-3" data-id="element-62" data-mp="ddf3qcby3q9t">
            {proofs.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 font-sans text-sm text-muted" data-id="element-63" data-mp="1b15ozdxthvoh">
                <Icon aria-hidden="true" className="h-4 w-4 text-terracotta" data-id="element-64" data-mp="161auz1iqwpz7" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <div className="relative" data-id="element-65" data-mp="x14o3yhjyo90">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/fe657bc2-7ebc-4a93-a678-5543d79c05d6.jpg" alt="Invitados riendo en una mesa de boda mientras juegan con tarjetas impresas" className="aspect-[4/3] w-full rounded-[1.5rem] object-cover" loading="eager" data-id="element-66" data-mp="x1w789tyqtie" />
          <div className="mt-6 flex items-baseline justify-between border-t border-blush pt-5 sm:mt-8" data-id="element-67" data-mp="1xb5o89ocuje0">
            <div data-id="element-68" data-mp="218tntq0zt0c8">
              <p className="font-sans text-xs uppercase tracking-[0.18em] text-muted" data-id="element-69" data-mp="269zivui4kzox">Valor total</p>
              <p className="font-display text-2xl text-muted line-through" data-id="element-70" data-mp="2b0plx132wqgg">{totalValue}</p>
            </div>
            <div className="text-right" data-id="element-71" data-mp="2g02kgj3bblyv">
              <p className="font-sans text-xs uppercase tracking-[0.18em] text-wine" data-id="element-72" data-mp="2fz0y3igujd1u">Hoy</p>
              <p className="font-display text-4xl font-semibold text-ink" data-id="element-73" data-mp="2kxu8v34r0pyb">
                {priceToday}
                <span className="ml-1.5 font-sans text-sm font-medium text-muted" data-id="element-74" data-mp="2p1sabkhjqcuj">ARS</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
}